module.exports = __webpack_public_path__ + "static/media/jieyue.d33c2cd0.png";